import { render, staticRenderFns } from "./MapCardTijuana.vue?vue&type=template&id=9a7a70d0&"
import script from "./MapCardTijuana.vue?vue&type=script&lang=js&"
export * from "./MapCardTijuana.vue?vue&type=script&lang=js&"
import style0 from "./MapCardTijuana.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports